import { mutatorAction } from 'satcheljs';
import { store } from 'owa-lightning-core-v2';

export const setLastShownLightning = mutatorAction(
    'setLastShownLightning',
    (lightningId: string) => {
        store.lastShownId = lightningId;
    }
);
